export const actionTypes = {
  setvariables: "setvariables",
};
const initstate = {
  variables: [],
};
export const workflowReducer = (state = initstate, action) => {
  switch (action.type) {
    case actionTypes.setvariables:
      return { variables: action.payload };
    default:
      return state;
  }
};
export const variablesActions = {

  setvariables: (variables) => ({ type: actionTypes.setvariables, payload: variables }),
};
